
import React from "react";
import { Card, CardContent } from "./ui/card";
import { Avatar, AvatarImage, AvatarFallback } from "./ui/avatar";
import brianChenHeadshot from "@/assets/founders/brian-chen.png";
import joeKnoppHeadshot from "@/assets/founders/joe-knopp.jpg";

const FoundersSection = () => {
  const founders = [
    {
      name: "Eric Shepard",
      role: "Co-Founder",
      bio: "Serial Entrepreneur with 15+ years in tech & played a key role in 3 exits. Founded TRILL Travel, an AI travel platform that was acquired by Lonely Planet.",
      image: "/lovable-uploads/9167bb88-dbc3-41d8-94cf-fc17bcb4b52b.png",
      fallback: "ES",
    },
    {
      name: "Will Lucas",
      role: "Co-Founder",
      bio: "Serial Entrepreneur with 20 years experience founding & leading 3 successful businesses. Most recently Founder, CEO of Mint House, (now Chairman of the Board).",
      image: "/lovable-uploads/b1b78551-4024-467f-a2af-0d6e1671f324.png",
      fallback: "WL",
    },
    {
      name: "Brian Chen",
      role: "Co-Founder",
      bio: "Former CEO and Co-Founder of ROOM, a category-defining modular workspace company.",
      image: brianChenHeadshot,
      fallback: "BC",
    },
    {
      name: "Joe Knopp",
      role: "Head of Operations",
      bio: "Entrepreneur who sold his last business in the events space and has developed and deployed smart access systems across Marriott properties.",
      image: joeKnoppHeadshot,
      fallback: "JK",
    },
  ];

  return (
    <section id="founders" className="py-16 md:py-24 bg-soft-blue">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="font-montserrat text-4xl md:text-5xl font-extrabold text-quietcove-blue mb-4">
            Experienced Founding Team
          </h2>
          <p className="text-quietcove-grey text-xl max-w-3xl mx-auto">
            With Deep Hospitality Experience
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12">
          {founders.map((founder) => (
            <Card key={founder.name} className="border-quietcove-sand shadow-md hover:shadow-lg transition-shadow bg-white">
              <CardContent className="pt-6">
                <div className="flex flex-col items-center">
                  <Avatar className="h-24 w-24 mb-4">
                    <AvatarImage src={founder.image} alt={founder.name} />
                    <AvatarFallback>{founder.fallback}</AvatarFallback>
                  </Avatar>
                  <div className="mb-4">
                    <div className="text-center mb-6">
                      <h3 className="text-2xl font-semibold text-quietcove-blue">{founder.name}</h3>
                      <p className="text-quietcove-green font-medium">{founder.role}</p>
                    </div>
                    <p className="text-quietcove-grey text-lg text-center">{founder.bio}</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FoundersSection;
